const sendYandexGoal = (goalName: string) => {
  if (process.env.IS_SERVER) {
    return
  }

  if (process.env.IS_PROD) {
    window.ym(window.YA_COUNTER_ID, 'reachGoal', goalName)
  }
}

export default sendYandexGoal
